import { render } from "./OrderItem.vue?vue&type=template&id=7bc00786&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"

import "./OrderItem.vue?vue&type=style&index=0&id=7bc00786&lang=scss&scoped=true"

import exportComponent from "/var/www/production/app.labparahita.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc00786"]])

export default __exports__